// extracted by mini-css-extract-plugin
export default {"tabs":"Tasks_tabs__oVrv-","tab":"Tasks_tab__YLLn1","activeKan":"Tasks_activeKan__3gahW","activeList":"Tasks_activeList__58jf+","kanban":"Tasks_kanban__2KNoy"};